/**
 * Generic Info component
 */
import { useSelector } from 'react-redux';
import { IStore } from '../../reducers';
import DexCoin from './DexCoin';
import CexCoin from './CexCoin';
import './styles.scss';

const InfoWidget = () => {
  const currentState = useSelector((state: IStore) => state.current);

  if (currentState.chain !== '') {
    return (
      <div className='info_widget'>
        <DexCoin current={currentState} />
      </div>
    );
  }

  return (
    <div className='info_widget'>
      <CexCoin current={currentState} />
    </div>
  );
};

export default InfoWidget;
